//TODO: maybe add flocks of small boxes flying aroung
//different animations and choose from them randomly on click

import * as THREE from "three";
import gsap from 'gsap';
import { getRandom } from './utils';

export default class PropMesh
{
	constructor(scene, terrainSize)
	{
		this.scene = scene;
		this.terrainSize = terrainSize;
		this.isAnimating = false;
		this.luminosityFact = 0;
		this.propMeshes = [];
		// this.lights = [];

		this.setup();	
	};

	setup()
	{
		const size = 1;
		let geometry = new THREE.BoxBufferGeometry(size, size*2, size);
		// let geometry = new THREE.CylinderBufferGeometry(size, size, size*2, 6);

		const group1 = new THREE.Object3D();
		const group2 = new THREE.Object3D();

		this.material = new THREE.MeshStandardMaterial(); //new THREE.MeshPhongMaterial({ ambient: 0x050505, color: 0x0033ff, specular: 0x555555, shininess: 30 }); //
		const xOffset = getRandom(-this.terrainSize/20, this.terrainSize/20);
		const zOffset = getRandom(-this.terrainSize/6, 0);
		const radStep = 30;
		const angleStep = Math.PI/3;
		let angle = angleStep;
		let radius = radStep;
		let index = 0;
		for(let i=0; i<50; i++) 
		{
			this.material.color.setHSL(getRandom(0, 1), .2, .5);
			let mesh = new THREE.Mesh(geometry, this.material);
			mesh.position.y = 10;
			mesh.position.x = xOffset + radius*Math.cos(angle);
			mesh.position.z = zOffset + radius*Math.sin(angle);
			mesh.rotation.y = -angle;
			mesh.scale.y = (4 - index) + 1;
			group1.add(mesh);

			// console.log(xOffset);
			// console.log('radius: ', radius*Math.cos(angle));
			let light = new THREE.PointLight(0xff5969, 1, 200, 2);
			light.position.set(xOffset + radius*Math.cos(angle), 1, zOffset + radius*Math.sin(angle));
			//console.log(light.position);
			// light.castShadow = true;
			group2.add(light);

			let meshSize = 2;//getRandom(2, 5);
			// let wfMesh = new THREE.LineSegments(
			// 	new THREE.EdgesGeometry(new THREE.SphereBufferGeometry(meshSize, 12)),
			// 	new THREE.LineBasicMaterial()
			// 	);
			let wfMesh = new THREE.Mesh(
				new THREE.SphereBufferGeometry(meshSize, 12),
				new THREE.MeshLambertMaterial({
					// color: 0xFF5969,
					wireframe: true
				})
				);
            wfMesh.position.set(mesh.position.x, mesh.position.y*2, mesh.position.z);
            group2.add(wfMesh);

			if(angle >= Math.PI*2) 
			{
				angle = angleStep;
				radius += radStep;
				index++;
			} 
			else 
			{
				angle += angleStep;
			}
		}

		this.scene.add(group1);
		this.scene.add(group2);
		this.propMeshes.push(group1);
	};

	update(time) 
	{
		this.luminosityFact = this.isAnimating ? .2 : 0;
		this.material.emissive.setHSL((Math.sin(time/2)+3)/4, (Math.sin(time/4)+3)/4, .2 + this.luminosityFact);
	}

	onAction(e) 
	{
		if(this.isAnimating) return;

		if(e) 
		{
			for(let i=0; i<this.propMeshes[0].children.length; i++)
			{
				this.changeColor();
				this.bump(this.propMeshes[0].children[i]);
			}
		}
	};

	changeColor() 
	{
		this.material.color.setHSL(getRandom(0, 1), .5, .5);
	};

	bump(mesh) 
	{	
		this.isAnimating = true;
		const originalScaleX = mesh.scale.z;
		const originalScaleY = mesh.scale.y;
		const originalScaleZ = mesh.scale.z;
		const easing = 'bounce';

		let bump = gsap.timeline();
		bump.to(mesh.scale, 1, {x: 1.02, y: 1.02, z: 1.02, ease:easing})
			.to(mesh.scale, 1, {x: originalScaleX, y: originalScaleY, z: originalScaleZ, ease:easing});
		
		bump.eventCallback("onComplete", () =>
		{
			this.isAnimating = false;
		});

	};
	
	rotate(mesh) 
    {
        let tween = gsap
			.to(mesh.rotation, 10, {y: mesh.rotation.y+Math.PI/2, z: mesh.rotation.z+Math.PI/2});
        tween.play();
	};
}
	